'use client';

import { cn } from '@/core/utils/cn';

interface Tab {
  id: string;
  label: string;
  count?: number;
  icon?: React.ReactNode;
}

interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (id: string) => void;
  className?: string;
  idPrefix?: string;
}

export function Tabs({ tabs, activeTab, onChange, className, idPrefix }: TabsProps) {
  return (
    <div role="tablist" id={idPrefix ? `${idPrefix}-list` : undefined} className={cn('flex items-center gap-1 border-b border-hms-border overflow-x-auto scrollbar-hide', className)}>
      {tabs.map((tab) => (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === tab.id}
          key={tab.id}
          id={idPrefix ? `${idPrefix}-${tab.id}` : undefined}
          onClick={() => onChange(tab.id)}
          className={cn(
            'flex items-center gap-1.5 px-3 py-2.5 text-[13px] font-medium transition-colors relative whitespace-nowrap flex-shrink-0',
            activeTab === tab.id
              ? 'text-hms-gold'
              : 'text-hms-textDim hover:text-hms-textSub'
          )}
        >
          {tab.icon}
          {tab.label}
          {tab.count !== undefined && (
            <span className={cn(
              'text-[10px] px-1.5 py-0.5 rounded-full',
              activeTab === tab.id ? 'bg-hms-gold/10 text-hms-gold' : 'bg-white/5 text-hms-textDim'
            )}>
              {tab.count}
            </span>
          )}
          {activeTab === tab.id && (
            <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-hms-gold rounded-t" />
          )}
        </button>
      ))}
    </div>
  );
}
